import { pathJoin } from '../../utils'

export const createMarketPlaceRouteMap = (prefix: string) => ({
  'checkout/:stripeQuoteId': (stripeQuoteId: string) =>
    pathJoin(prefix)('checkout')(stripeQuoteId).chain,
  'shop/:stripeQuoteId': (stripeQuoteId: string) =>
    pathJoin(prefix)('shop')(stripeQuoteId).chain,
})
